







import Vue from "vue";

export default Vue.extend({
  created() {
    addEventListener("offline", this.offline);
    addEventListener("online", this.online);
  },
  beforeDestroy() {
    removeEventListener("offline", this.offline);
    removeEventListener("online", this.online);
  },
  data() {
    return {
      isOffline: false,
    };
  },
  methods: {
    /** オフラインになった時 */
    offline() {
      this.isOffline = true;
    },
    online() {
      this.isOffline = false;
    },
  },
});
